<template>
  <div class="time">
    <div class="sensor-top">
      <div
        class="sensor-top-left"
        style="display: flex; align-items: center; justify-content: flex-start"
      >
        <div class="two-font-wrapper" @click="back">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
        <div class="two-font-wrapper" @click="toHistory">
          <div class="icon-font">&#xe65b;</div>
          历史曲线
        </div>
        <div
          class="history-title"
          style="margin-left: 5vw; font-weight: bold"
          v-if="!loading"
        >
          设备ID：{{ nodeId }}，采集位置：{{ stack }}{{ maintainStage }}。
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="detail-item" style="width: 50%" v-if="nodeType === '01'">
            氧气(%)
          </div>
          <div class="detail-item" style="width: 50%" v-if="nodeType === '02'">
            二氧化碳(PPM)
          </div>
          <div class="detail-item" style="width: 25%" v-if="nodeType === '03'">
            温度(℃)
          </div>
          <div class="detail-item" style="width: 25%" v-if="nodeType === '03'">
            湿度(%)
          </div>
          <div class="detail-item" style="width: 50%" v-if="nodeType === '04'">
            温度(℃)
          </div>
          <div class="detail-item" style="width: 50%" v-if="nodeType === '05'">
            水分(%)
          </div>
          <div class="detail-item" style="width: 50%">采集时间</div>
        </div>
        <div class="detail-content">
          <div
            class="detail-list-wrapper"
            v-if="!loading && tableData.length > 0"
            v-for="(data, index) in tableData"
            :key="index"
          >
            <div
              class="detail-item"
              style="width: 50%"
              v-if="nodeType === '01'"
            >
              {{ data.oxygen }}
            </div>
            <div
              class="detail-item"
              style="width: 50%"
              v-if="nodeType === '02'"
            >
              {{ data.concentrationCo2  }}
            </div>
            <div
              class="detail-item"
              style="width: 25%"
              v-if="nodeType === '03'"
            >
              {{ data.airTemp  }}
            </div>
            <div
              class="detail-item"
              style="width: 25%"
              v-if="nodeType === '03'"
            >
              {{ data.airMoisture  }}
            </div>
            <div
              class="detail-item"
              style="width: 50%"
              v-if="nodeType === '04'"
            >
              {{ data.temp  }}
            </div>
            <div
              class="detail-item"
              style="width: 50%"
              v-if="nodeType === '05'"
            >
              {{ data.moist  }}
            </div>
            <div class="detail-item" style="width: 50%">
              {{ renderTime(data.createdTime) }}
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length < 1">
            暂无数据
          </div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">
            共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
              rows
            }}条，当前第{{ page }}页
          </div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="Tzpage">跳转至</div>
            <div class="page-btn"><input v-model="page" /></div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNodeHistory } from "../../../../api/maintain";
import { renderTime } from "../../../../tools/methods";
import localforage from 'localforage'
export default {
  name: "SensorHistory",
  data() {
    return {
      loading: true,
      page: 1,
      rows: 7,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
      stack: "",
      nodeId: "",
      nodeType: "",
      siteId: "",
      siteType: "",
      maintainStage: "",
    };
  },
  created() {
    let _this = this
    localforage.getItem('page_rem_core_history').then(res => {
      if (res) {
        _this.page=res
      }
    })
    this.handleSearch(1);
  },
  methods: {
    renderTime: function (time) {
      return renderTime(time);
    },
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1;
      }
      this.loading = true;
      let body = {
        nodeId: this.$route.query.nodeId,
        page: this.page,
        rows: this.rows,
      };
      getNodeHistory(body)
        .then((res) => {
          console.log(res);
          this.stack = res.data.nodeInfo.stack;
          this.nodeId = res.data.nodeInfo.nodeId;
          this.nodeType = res.data.nodeInfo.nodeType;
          this.siteId = res.data.nodeInfo.siteId;
          this.siteType = res.data.nodeInfo.siteType;
          this.tableData = res.data.history.rows;
          this.total = res.data.history.total;
          if (res.data.maintainStage === "01") {
            this.maintainStage = "，养护阶段：自然醇化阶段";
          } else if (res.data.maintainStage === "02") {
            this.maintainStage = "，养护阶段：防霉杀虫阶段";
          } else if (res.data.maintainStage === "03") {
            this.maintainStage = "，养护阶段：气调醇化阶段";
          } else if (res.data.maintainStage === "04") {
            this.maintainStage = "，养护阶段：气调保质阶段";
          } else {
            this.maintainStage = "";
          }
          // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    toHistory: function () {
      if (this.nodeType === "01") {
      } else if (this.nodeType === "02") {
      } else if (this.nodeType === "03") {
      } else if (this.nodeType === "04") {
        this.$router.push({
          path: "/core/historyCurve",
          query: {
            index: this.$route.query.index,
            stack: this.stack,
            nodeId: this.nodeId,
            siteId: this.siteId,
            siteType: this.siteType,
            maintainStage: this.maintainStage,
            value: "0",
          },
        });
      } else if (this.nodeType === "05") {
        this.$router.push({
          path: "/core/historyCurve/historyWater",
          query: {
            index: this.$route.query.index,
            stack: this.stack,
            nodeId: this.nodeId,
            siteId: this.siteId,
            siteType: this.siteType,
            maintainStage: this.maintainStage,
            value: "1",
          },
        });
      }
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      } else {
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        localforage.setItem('page_rem_core_history', this.page)
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Time.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/timeMonitoring/SensorHistory.vue